import { TransportEmployeeNumber } from "../../../../../../store/types/userTypes";

/**
 * El legajo del chofer se guarda por empresa de transporte, así que sólo tiene sentido una vez
 * elegida la empresa. Devuelve "" cuando no hay empresa o cuando el chofer no tiene legajo en ella.
 */
export const resolveEmployeeNumber = (
  list: TransportEmployeeNumber[] | undefined,
  companyId: string | undefined | null
): string => {
  if (!companyId || !list?.length) return "";

  const match = list.find((entry) => String(entry.transportCompany) === String(companyId));
  return match?.employeeNumber || "";
};
